import { SYSTEM_ACTION_TYPES } from './system.types';
import { GRADIENT_DATA } from '../../data/theme-data/gradient-data';

export const setBgIsChanging = (status) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_BG_IS_CHANGING, payload: !status });
}
export const setDisplayedGradient = (gradientType) => {
    return { type: SYSTEM_ACTION_TYPES.SET_DISPLAYED_GRADIENT, payload: gradientType}
};
export const setDefaultGradient = (gradient) => {
    return ({type: SYSTEM_ACTION_TYPES.SET_DEFAULT_GRADIENT, payload: gradient }); 
}
export const setGradient = (gradientType, presetIndex=null) => {
    const newTeamIndex = Math.floor(Math.random() * Object.keys(GRADIENT_DATA).length);

    if (gradientType === "A") {
        return ({ type: SYSTEM_ACTION_TYPES.SET_GRADIENT_A, payload: presetIndex ? presetIndex : newTeamIndex });
    } else if (gradientType === "B") {
        return ({ type: SYSTEM_ACTION_TYPES.SET_GRADIENT_B, payload: presetIndex ? presetIndex : newTeamIndex });
    } else {
        alert("Error: Error changing background :(")
    }
}
let _notificationTimerId = null;

export const setSystemNotification = (text) => {
    return (dispatch) => {
      if (_notificationTimerId) {
        clearTimeout(_notificationTimerId);
        _notificationTimerId = null;
      }

      dispatch({ type: SYSTEM_ACTION_TYPES.SET_SYSTEM_NOTIFICATION, payload: text });

      _notificationTimerId = setTimeout(() => {
        dispatch({ type: SYSTEM_ACTION_TYPES.SET_SYSTEM_NOTIFICATION, payload: null });
        _notificationTimerId = null;
      }, 3000);
    };
  };

export const setCriticalMessage = (text) => {
    return { type: SYSTEM_ACTION_TYPES.SET_CRITICAL_MESSAGE, payload: text };
};

  export const setChecklistSportDefault = (sport) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_CHECKLIST_SPORT_DEFAULT, payload: sport });
  }
  export const setChecklistYearDefault = (year) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_CHECKLIST_YEAR_DEFAULT, payload: year });
  }
  export const setChecklistManufacturerDefault = (manufacturer) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_CHECKLIST_MANUFACTURER_DEFAULT, payload: manufacturer });
  }
  export const setChecklistSeriesDefault = (series) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_CHECKLIST_SERIES_DEFAULT, payload: series });
  }
  export const setChecklistCardTypeDefault = (cardType) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_CHECKLIST_CARD_TYPE_DEFAULT, payload: cardType });
  }
  export const setChecklistCardTypeCategoryDefault = (cardTypeCategory) => {
    return ({ type: SYSTEM_ACTION_TYPES.SET_CHECKLIST_CARD_TYPE_CATEGORY_DEFAULT, payload: cardTypeCategory });
  }

  export const resetSystemState = () => {
    return { type: SYSTEM_ACTION_TYPES.RESET_SYSTEM_STATE };
  }